import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {getChildObjectComponentByType} from "../../../helpers/componentHelper";

class MultipleChoice extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            initialised: false,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            character_name: appHelper.isDefined(this.props.callbacks) ? this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            screenObject: this.props.screenObject,
            locale: appHelper.getLocalData(this.props.screenObject),
            questionType:{},
            promptRevealed: this.props.screenObject.prompt_type === objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT,
            callbacks:{},
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(),this.props.callbacks.getScreenId(),this.props.screenObject.asset_id),
            checkObjectStatus: false,
        };
        this.getAssets = this.getAssets.bind(this);
        this.getQuestionType = this.getQuestionType.bind(this);
        this.onPromptRevealed = this.onPromptRevealed.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.scrollToFeedback = this.scrollToFeedback.bind(this);
        this.scrollToSubmitBtn = this.scrollToSubmitBtn.bind(this);
        this.setCallbacks =  this.setCallbacks.bind(this);
        this.scrollOptionsToTop = this.scrollOptionsToTop.bind(this);
        this.scrollToContinue = this.scrollToContinue.bind(this);
    }

    componentDidMount() {
        this.setCallbacks();
        this.getQuestionType();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({},nextProps.userData)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject)
            });
        }
    }

    componentDidUpdate() {
    }

    getAssets(){
        let objectUserData = {};
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            let subScreenParent = this.props.callbacks.getSubScreenParent();
            let screen_id = this.props.callbacks.getScreenId();
            if (appHelper.isDefined(subScreenParent)) {
                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
            } else if (this.state.isResourceObject) {
                objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
            } else {
                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
            }
        }

        /*if (appHelper.isDefined(this.state.screenObject.audio) && this.state.screenObject.asset_type_code !== componentConstants.AUDIO_CHOICE) {
            let audio = appHelper.getAudioAsset(this.state.screenObject.audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`,
            };

            //if (objectUserData.status !== objectConstants.STATUS_COMPLETE) {
                this.props.actions.setAudio(audioObj);
            //}
        }*/
    }

    getQuestionType(){
        let questionType = Object.assign({}, getChildObjectComponentByType(`${this.state.screenObject.asset_type_code}_${this.state.screenObject.selection_type}`),
            {
                data: this.state.screenObject
            }
        );
        this.setState({
            questionType: Object.assign({},questionType),
            initialised:  true
        });
    }

    onPromptRevealed(){
        this.setState({promptRevealed: true});
    }

    setCallbacks(){
        this.setState({callbacks: Object.assign({}, this.props.callbacks,
            {
                scrollToTop: this.scrollToTop,
                scrollToFeedback: this.scrollToFeedback,
                scrollToSubmitBtn: this.scrollToSubmitBtn,
                scrollOptionsToTop: this.scrollOptionsToTop,
                scrollToContinue: this.scrollToContinue
            }
        )});
    }

    scrollToTop() {
        let subScreenParent = this.props.callbacks.getSubScreenParent();
        let objectUserData = {};
        let screen_id = this.props.callbacks.getScreenId();
        if (appHelper.isDefined(subScreenParent)) {
            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
        } else {
            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
        }
        if(this.state.allowScroll && (objectUserData.status !== objectConstants.STATUS_COMPLETE)) {
            let question = this.refs[`${this.state.screenObject.asset_id}_question`];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                scrollTo(question.offsetTop);
            }, objectConstants.SCROLL_TO);
        }
    }

    scrollToFeedback(feedbackPos) {
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop + feedbackPos, true);
        }, objectConstants.SCROLL_TO);
    }

    scrollToSubmitBtn(submitBtnOffset){
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop + submitBtnOffset);
        }, objectConstants.SCROLL_TO);
    }

    scrollOptionsToTop(questionOptionsOffset) {

         let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop + questionOptionsOffset);
        }, objectConstants.SCROLL_TO);
    }

    scrollToContinue(){
        let question = this.refs[`${this.state.screenObject.asset_id}_question`];
        let scrollTo = this.props.callbacks.scrollTo;
        setTimeout(function () {
            scrollTo(question.offsetTop, true);
        }, objectConstants.SCROLL_TO);
    }

    render() {
        let QuestionType =  this.state.questionType;
        return (
            <div  ref={`${this.state.screenObject.asset_id}_question`}>
                {
                    this.state.initialised
                    ? <QuestionType.component screenObject={QuestionType.data} callbacks={this.state.callbacks} characterPose={this.props.characterPose} index={this.props.index}/>
                    :  null
                }
            </div>
        );
    }
}

MultipleChoice.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    characterPose: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    index: PropTypes.number,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

MultipleChoice.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleChoice);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/MultipleChoice.js
 **/